import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarWashinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "M7 5h50M33.61 53H10V40.387C10 37.462 11.873 36 15.62 36h32.76c3.747 0 5.62 1.462 5.62 4.387V53H33.61z" }), /* @__PURE__ */ _jsx("path", { d: "M18.5 47a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm27 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zM32 22h7.824c5.029 0 5.546 1.196 7.823 6.462C49.165 31.972 50.283 34.485 51 36H13c.717-1.515 1.835-4.028 3.353-7.538C18.63 23.196 19.147 22 24.176 22H32zM16 53v6m32-6v6M21 8s3 3.578 3 5.151C24 14.725 22.657 16 21 16s-3-1.275-3-2.849C18 11.578 21 8 21 8zm11 0s3 3.578 3 5.151C35 14.725 33.657 16 32 16s-3-1.275-3-2.849C29 11.578 32 8 32 8zm11 0s3 3.578 3 5.151C46 14.725 44.657 16 43 16s-3-1.275-3-2.849C40 11.578 43 8 43 8z" })]
	})
});
export default SvgCarWashinline;
